import React from 'react'
import '../css/label.css'
export default function Label({ controlId, className, labelText, isCompulsary }) {
    return (
        <label htmlFor={controlId} className={className ? className : ""} >
            {labelText} {isCompulsary && <span className="text-danger">*</span>}
        </label >
    )
}
